define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/def",
	"csi/html",
	"csi/sessionConstants",
	"csi/def/Action"
], function(declare, _, def, html, sessionConstants, Action) {

	function onDrawDirectEdit(/*Context*/ctx, /*Action*/a, /*DOMNode?*/refNode) {
		// if refNode is not specified - no drawings, only verify for action availability.
		// figure out if this node is eligible for DirectEdit
		const node = ctx.getNode();

		// if file is in PROOFING state, do nothing
		if (node.State == "Revision.State:PROOFING") {
			return null;
		}

		if (node.IsDriveFile)
			return null; // not supported, so nothing to do

		// check 1) see if there is a valid file to check
		const filename = node["File.File"];
		if (!filename)
			return null; // not a valid file, so nothing to do

		// check 2) see if it has a valid Illustrator extension
		const validExtensions = sessionConstants.validIllustratorExtensions;

		// check extension of the filename
		const hasValidExtension = _.some(validExtensions, function(validExtension) {
			return filename.toLowerCase().endsWith(validExtension.toLowerCase());
		});

		if (!hasValidExtension)
			return null; // not a valid extension, so nothing to do

		// check 3) it has to be under one of 14 parent types
		const validParentTypes = ["Style", "Collection", "Category2", "Category1", "Season", "Material", "Theme", "Shape", "PrintSpecification", "PrintDesign", "PrintDesignColor", "Site", "DocumentGroup", "Sample"];
		// actually "parent" is 3 levels up, since DocumentRevision -> Document -> DocumentContainer -> X
		const parent = ctx.cache.getNode(ctx.cache.getNode(ctx.cache.getNode(node.__Parent__).__Parent__).__Parent__);
		const parentType = parent == null ? "Site" : parent.$Type; // Site level doesn't have a parent

		const hasValidParentType = _.some(validParentTypes, function(validParentType) {
			return parentType == validParentType;
		});

		if (!hasValidParentType)
			return null; // not a valid parent type, so nothing to do

		// we made it - render Ai link
		return html.create("a", {
			href: "csilocal://NODE/" + node.$URL,
			"class": "csiAction csiActionIcon iconDirectEditAI",
			"target": "DirectEditAI",
			title: a.getDescription()
		}, refNode);
	}

	return declare(Action, {
		constructor: function(obj) {
			this.m_drawAction = onDrawDirectEdit;
			if (!this.m_typeControl) {
				this.m_typeControl = def.ACTION_ICON;
				this.m_class = "iconDirectEditAI " + (this.m_class || "");
			}
		}
	});
});